import {read} from './cookie.js';

const customer = {
    getCustomerToken: function() {
        var cookie = read('EQCookie'),
            token = cookie ? cookie.split('=')[1] : '';
        return token;
    }
};
export default customer;
